import {type ModalPage} from '../models/IEnvironment';
import {Feature} from '../reducers/environmentReducer';
import {$qs, $qsAll} from '../../../@shared/ts/dom';
import {FeatureFlag} from '../../../@type/features';
import {openCart, openCartWithKeyPress} from './slideUpView';

export function renderModalPage(modalPage: ModalPage) {
	renderInfoPageDisplay(modalPage);
	renderShippingPageDisplay(modalPage);
	renderPaymentPageDisplay(modalPage);
	renderModalButtonShadow();

	$qs('#pp-dropdown-new')?.addEventListener('click', openCart);
	$qs('#pp-dropdown-new')?.addEventListener('keypress', openCartWithKeyPress);
}

/**
 * Renders or shows the info page elements
 */
function renderInfoPageDisplay(modalPage: ModalPage): void {
	if (modalPage === 'info') {
		$qs('#pp-info')?.classList.remove('hide');
	} else {
		// Hide info page
		$qs('#pp-info')?.classList.add('hide');
	}
}

/* Updates the UI for the case: modalUI === 'shipping'  */
function renderShippingPageDisplay(
	modalPage: ModalPage,
): void {
	if (modalPage === 'shipping') {
		$qs('#pp-shipping')?.classList.remove('hide');
	} else {
		// Hide shipping page
		$qs('#pp-shipping')?.classList.add('hide');
	}
}

/**
 * Handles changing the modal to the payment page
 */
function renderPaymentPageDisplay(
	modalPage: ModalPage,
): void {
	if (modalPage === 'payment') {
		// Show payment page
		$qs('#pp-payment')?.classList.remove('hide');
		$qs('#extra-fields-section')?.classList.remove('hide');
	} else {
		// Hide payment page
		$qs('#pp-payment')?.classList.add('hide');
	}
}

/**
 * Updates the modals colors to match the merchants button color.
 */
function renderModalButtonShadow(): void {
	const buttonShadowClass = 'btn-shadow';

	if (Feature.enabled(FeatureFlag.BUTTON_SHADOW)) {
		$qsAll('.btn', $element => {
			$element.classList.add(buttonShadowClass);
		});
	} else {
		$qsAll('.btn', $element => {
			$element.classList.remove(buttonShadowClass);
		});
	}
}
